import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  subTitle: {
    fontWeight: 600,
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: neutral[60],
    textTransform: 'uppercase',
  },

  baseSections: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
});
